import { render, staticRenderFns } from "./JigActions.vue?vue&type=template&id=1165879f"
import script from "./JigActions.vue?vue&type=script&lang=ts"
export * from "./JigActions.vue?vue&type=script&lang=ts"
import style0 from "./JigActions.vue?vue&type=style&index=0&id=1165879f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports